// Brand + contact + office map details (single source of truth for the frontend).
export const BRAND = {
  name: "Alvin Kumar & Associates",
  short: "AK Fiji",
  mark: "AK",
  legalEntity: "Alvin Kumar & Associates (trading as AK Fiji)",
  taxAgent: "FRCS Registered Tax Agent No. 1065",
  principal: "Alvin Kumar",
  taxSite: "https://akfiji.com",
  taxSiteLabel: "akfiji.com",
};

const WHATSAPP_MESSAGE = "Hi Alvin Kumar & Associates, I'd like to enquire about your services.";

export const CONTACT = {
  email: "alvin@akfiji.com",
  emailHref: "mailto:alvin@akfiji.com",
  phone: "+679 714 2741",
  phoneHref: "tel:+6797142741",
  whatsapp: "https://wa.me/6797142741",
  whatsappChat: `https://wa.me/6797142741?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
  booking: "https://cal.com/alvinkumar/general-consultation",
  wechatId: "Alvin_Fiji",
  address: "Shop 2T4B, Level 3, RB Patel Jetpoint Complex, Martintar, Nadi, Fiji",
  hours: "Monday to Friday, 8:30am – 5:00pm (Fiji time)",
  reviewUrl: "https://www.google.com/maps/search/?api=1&query=Alvin%20Kumar%20%26%20Associates%2C%20RB%20Patel%20Jetpoint%20Complex%2C%20Martintar%2C%20Nadi%2C%20Fiji",
};

// Keyless Google Maps embeds (no API key required).
export const OFFICES = {
  nadi: {
    query: CONTACT.address,
    embed: "https://maps.google.com/maps?q=RB%20Patel%20Jetpoint%20Complex%2C%20Martintar%2C%20Nadi%2C%20Fiji&z=16&output=embed",
    link: "https://www.google.com/maps/search/?api=1&query=RB%20Patel%20Jetpoint%20Complex%2C%20Martintar%2C%20Nadi%2C%20Fiji",
  },
  suva: {
    query: "Suva, Fiji",
    embed: "https://maps.google.com/maps?q=Suva%2C%20Fiji&z=13&output=embed",
    link: "https://www.google.com/maps/search/?api=1&query=Suva%2C%20Fiji",
  },
};
